import React from "react";
import { ButtonGroup, Button } from "reactstrap";
import { Spinner } from "react-activity";
import "react-activity/dist/react-activity.css";
export const renderHotelsActions = (deleteAction, cellInfo) => {
  const deleteTarget = cellInfo.original && cellInfo.original.id ? cellInfo.original : cellInfo.index;
  return (
    <ButtonGroup className="hotels-action-group">
      <Button
        color="danger"
        title="Delete hotel"
        onClick={() => {
          deleteAction(deleteTarget);
        }}
      >
        <i className="fa  fa-trash" />
        {cellInfo.original.isDeleting ? (
          <>
            &nbsp;
            <Spinner size={10} animating={true} color={"white"} />
          </>
        ) : null}
      </Button>
    </ButtonGroup>
  );
};
